import { Button, SceneWrapper, Typography } from '~/components';
import { Icon, getTheme, pxToRem, styled } from '~/modules';
import { mqDevices } from '~/utils';

const spacingSm = getTheme('spacing.sm');
const spacingMd = getTheme('spacing.md');
const spacingLg = getTheme('spacing.lg');
const spacingXl = getTheme('spacing.xl');
const spacingXxl = getTheme('spacing.xxl');

export const Wrapper = styled(SceneWrapper)`
  flex: 1;
`;

export const Container = styled.div`
  width: 100%;
  padding: ${spacingXxl}px 0;

  @media ${mqDevices.inMobileAndTablet} {
    flex-direction: column;
  }
`;

export const UserInfoColumn = styled.div`
  flex-direction: column;
  gap: ${spacingXl}px;
  flex: 1;
  max-width: ${pxToRem(400)};

  @media ${mqDevices.inMobileAndTablet} {
    max-width: 100%;
  }
`;

export const ContentColumn = styled.div`
  flex: 1;
  flex-direction: column;
  margin-left: ${spacingLg}px;

  @media ${mqDevices.inMobileAndTablet} {
    margin-left: 0;
    margin-top: ${spacingXxl}px;
  }
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacingMd}px;
  margin-bottom: ${spacingLg}px;
`;

export const ActionsTitle = styled(Typography).attrs({ variant: 'md' })`
  font-weight: bold;
  margin-bottom: ${spacingMd}px;
`;

export const ActionsRow = styled.div`
  display: flex;
  gap: ${spacingXl}px;
  align-items: end;
`;

export const FiltersGroup = styled.div`
  flex: 1;
  gap: ${spacingSm}px;
  flex-wrap: wrap;
`;

export const FilterItem = styled.div`
  flex: 1 1 250px;
`;

export const ExportPDFButton = styled(Button)`
  gap: ${spacingMd}px;
  height: 3rem;
`;

export const SearchIconBox = styled(Button)`
  width: ${pxToRem(30)};
  height: ${pxToRem(30)};
  justify-content: center;
  align-items: center;
  align-self: flex-end;

  cursor: pointer;
`;

export const IconSearch = styled(Icon)`
  font-size: ${pxToRem(14)};
  font-weight: 900;
`;
